<template>
  <div class="relative w-full h-full">
    <apexchart :id="chartid"
               :options="chart_options"
               :series="series"
               height="100%"
               width="100%" />
  </div>
</template>

<script>
export default {
  name: "Graph",
  props: {
    chartid: {
      type: String,
      default: "chartName"
    },
    chartdata: {
      type: Array,
      default: () => [110, 90, 80, 70, 60, 50, 40, 35, 30, 25, 15]
    }
  },
  data() {
    return {
      background_color: [],
      chart_options: {},
      toFixedChartData: [],
      formattedLables: [],
      series: []
    }
  },
  computed: {
    changed() {
      return this.$store.state.ui.darkMode
    }
  },
  watch: {
    changed() {
      this.generateColors(this.changed)
    }
  },
  created() {
    this.chartdata.map((x) => {
      this.toFixedChartData.push(x.data.map((point) => this.formatToFixed(point)))

      this.series.push({
        ...x,
        name: "",
        borderRadius: 13,
        minBarLength: 10,
        borderSkipped: true,
        data: x.data.map((point) => this.formatToFixed(point))
      })
      this.formattedLables = x.labels.map((point) => (Number(point) ? this.formatPoint(Number(point)) : point))
      this.background_color.push(x.backgroundColor[0])
    })
    this.createChart()
  },
  methods: {
    formatPoint(datapoint) {
      return this.$utils.truncateNumber(datapoint)
    },
    formatToFixed(datapoint) {
      try {
        return Number(datapoint).toFixed(2)
      } catch (error) {
        return 0
      }
    },
    createChart() {
      this.chart_options = {
        theme: {
          mode: this.$store.state.ui.darkMode ? "dark" : "light"
        },
        grid: {
          show: false,
          padding: {
            top: -20,
            right: 0,
            bottom: -10,
            left: 0
          }
        },
        chart: {
          width: 100,
          background: this.$store.state.ui.darkMode ? "#2b3c44" : "transparent",
          type: "area",
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2
        },
        xaxis: {
          categories: this.formattedLables,
          tooltip: {
            enabled: false
          },
          labels: {
            show: false,
            style: {
              colors: this.$store.state.ui.darkMode ? "white" : "black"
            }
          },
          axisBorder: {
            show: false // Set this property to false to hide the x-axis line
          },
          axisTicks: {
            show: false // Set this property to false to hide the x-axis tick lines
          }
        },
        yaxis: {
          labels: {
            show: false,
            style: {
              colors: this.$store.state.ui.darkMode ? "white" : "black"
            }
          },
          axisBorder: {
            show: false // Set this property to false to hide the x-axis line
          }
        },
        fill: {
          opacity: 0
        }
      }
      // eslint-disable-next-line vue/no-undef-properties
      this.chart_options["colors"] = this.background_color
    },
    generateColors(isDarkMode) {
      this.chart_options = {
        chart: {
          background: this.$store.state.ui.darkMode ? "#2b3c44" : "transparent"
        },
        title: {
          style: {
            color: this.$store.state.ui.darkMode ? "#FFF" : "#000"
          }
        },
        theme: {
          mode: isDarkMode ? "dark" : "light"
        },
        grid: {
          show: false
        },
        xaxis: {
          labels: {
            show: false,
            style: {
              colors: isDarkMode ? "white" : "black"
            }
          }
        },
        yaxis: {
          labels: {
            show: false,
            style: {
              colors: isDarkMode ? "white" : "black"
            }
          }
        }
      }
    }
  }
}
</script>
